import {Appender} from './Appender.js';
import {ListenerHelper} from './ListenerHelper.js';
import {HTMLElementNotFoundError} from './errors/HtmlElementNotFoundError.js';
import axios from 'axios';

const STEP_LOADING_NAME = 'loading';
const STEP_UPLOAD_IMAGE_NAME = 'upload-image';
const STEP_VEHICULE_CHOICE_NAME = 'vehicule-choice';
const STEP_WHEEL_CHOICE_NAME = 'wheel-choice';
const STEP_LOAD_INDEX_CHOICE_NAME = 'load-index-choice';
const STEP_SPEED_INDEX_CHOICE_NAME = 'speed-index-choice';
const STEP_FINAL_NAME = 'result';
const STEP_ERROR_GENERAL_NAME = 'error-general';
const STEP_ERROR_CORNER_NAME = 'error-corner';
const STEP_ERROR_FAR_AWAY_NAME = 'error-far-away';
const FILE_UPLOAD_FORM_ID = 'axTyreMotionForm';
const AXTYREMOTION_MODAL_ID = 'tyremotionModal';
const AXTYREMOTION_RESULT_SEARCH_ID_ALL = 'axTyreMotionAllResult';
const AXTYREMOTION_RESULT_SEARCH_ID = 'axTyreMotionResultSearch';
const AXTYREMOTION_CURRENT_RESULT_SEARCH_ID = 'axTyreMotionCurrentResultSearch';
const STEPS_ELEMENTS_SELECTOR = '.step';

export class AxtyreMotion {

    constructor() {

        if(!this.isTyremotionHealthy()) {
            const axTyremotionButton = document.querySelector('.axTyremotionButton');
            if(null !== axTyremotionButton) axTyremotionButton.remove();
        } else {
            this.step = STEP_UPLOAD_IMAGE_NAME;
            this.runflatChoice = null;
            this.speedIndexChoice = null;
            this.loadIndexChoice = null;

            const form = document.getElementById(FILE_UPLOAD_FORM_ID);
            if(!Boolean(form)) throw new HTMLElementNotFoundError('No form found');
            this.fileUploadForm = form;

            const modal = document.getElementById(AXTYREMOTION_MODAL_ID);
            if(!Boolean(modal)) throw new HTMLElementNotFoundError('No modal found');
            this.modal = modal;

            const axTyreMotionAllResult = document.getElementById(AXTYREMOTION_RESULT_SEARCH_ID_ALL);
            const axTyreMotionResultSearch = document.getElementById(AXTYREMOTION_RESULT_SEARCH_ID);
            const axTyreMotionCurrentResultSearch = document.getElementById(AXTYREMOTION_CURRENT_RESULT_SEARCH_ID);
            const axTyreMotionTyreChoice = document.getElementById('axTyreMotionTyreChoice');
            this.listenerHelper = new ListenerHelper(this.modal, axTyreMotionAllResult, axTyreMotionTyreChoice);
            this.appender = new Appender(axTyreMotionResultSearch, axTyreMotionCurrentResultSearch, axTyreMotionTyreChoice);

            const stepElements = Array.from(this.modal.querySelectorAll(STEPS_ELEMENTS_SELECTOR));
            if(!stepElements.length) throw new HTMLElementNotFoundError('No steps found in AxtyreMotionModal');
            this.stepsElements = stepElements;
            this.init();
        }
    }

    init = () => {
        this.handleFileUpload(this.fileUploadForm);
        this.handleFormSubmit();
        this.setUpButtonNavigation();
    }

    handleFileUpload = (formElement) => {
        const fileInput = formElement.querySelector('input[type="file"]');
        const customFileInput = formElement.querySelector('.file-custom');
        if(!Boolean(fileInput) || !Boolean(customFileInput)) throw new HTMLElementNotFoundError('No file input or custom file input found');
        fileInput.addEventListener('change', () => {
            const filename = fileInput.value.split(/(\\|\/)/g).pop();
            if(!filename) return;
            customFileInput.style.setProperty('--_selected-file-text', "'" + filename + "'");
            this.handleFormSubmitCallback(new Event('submit'));
        })
    }

    handleFormSubmitCallback = (event) => {
        event.preventDefault();
        const formData = new FormData(this.fileUploadForm);
        const headers = { 'Authorization': 'Bearer ' + ax_tyremotion.api_key };
        this.goToStep(STEP_LOADING_NAME);
        axios.post( ax_tyremotion.api_url, formData, { headers })
            .then(response => {
                if (response.data.error) {
                    //handle Api errors
                    switch (response.data.error.code) {
                        case 4:
                            this.goToStep(STEP_ERROR_CORNER_NAME);
                            break;
                        case 5:
                            this.goToStep(STEP_ERROR_FAR_AWAY_NAME);
                            break;
                        default:
                            this.goToStep(STEP_ERROR_GENERAL_NAME);
                            break;
                    }
                } else {
                    const results = response.data.result.car_models;
                    if(!results.length) return;
                    this.setupResultsTopInfo(results, response);
                    results.forEach((result) => this.appender.appendResultModel(result));
                    this.listenerHelper.addClickEventListenerResults();
                    this.goToStep(STEP_VEHICULE_CHOICE_NAME);
                }
            })
            .catch((error) => {
                console.error(error);
                this.goToStep(STEP_ERROR_GENERAL_NAME);
            })
    }


    handleFormSubmit = () => {
        this.fileUploadForm.addEventListener('submit', this.handleFormSubmitCallback)
    }

    goToStep = (stepName) => {
        if(stepName === this.step) return;
        if(this.step === STEP_VEHICULE_CHOICE_NAME && stepName === STEP_UPLOAD_IMAGE_NAME) this.listenerHelper.cleanResultsStep();
        if(this.step === STEP_WHEEL_CHOICE_NAME && stepName === STEP_VEHICULE_CHOICE_NAME) this.listenerHelper.cleanChoicesStep();
        if(stepName === STEP_WHEEL_CHOICE_NAME) {
            this.speedIndexChoice = null;
            this.loadIndexChoice = null;
            this.listenerHelper.cleanChoicesStep();
        }
        if(STEP_VEHICULE_CHOICE_NAME === stepName) {
            const axTyreMotionResultSearchAll = document.getElementById(AXTYREMOTION_RESULT_SEARCH_ID_ALL);
            const axTyreMotionAllResult = document.getElementById(AXTYREMOTION_RESULT_SEARCH_ID);
            if(!Boolean(axTyreMotionResultSearchAll) || !Boolean(axTyreMotionAllResult)) throw new HTMLElementNotFoundError('No result search container found');

            //handle dropdown visibility if only one result
            axTyreMotionAllResult.classList.toggle('single', axTyreMotionAllResult.childElementCount === 1)
            
            //handle active button if both current and models list are available
            if(axTyreMotionResultSearchAll.classList.contains('both')) {
                const btnActive = axTyreMotionResultSearchAll.querySelector('#axTyreMotionCurrentResultSearch .btn')
                const buttons = axTyreMotionResultSearchAll.querySelectorAll('.btn');
                buttons.forEach(button => button.classList.remove('active'));
                btnActive.classList.add('active');
                document.querySelector('button[data-step="wheel-choice"]').disabled = false;
            }

            //Handle confirm button text
            const buttonConfirm = document.querySelector('.step[data-step="vehicule-choice"] button[data-step="wheel-choice"]');
            if(!Boolean(buttonConfirm)) throw new HTMLElementNotFoundError('No confirm button found');
            buttonConfirm.textContent =
                axTyreMotionResultSearchAll.classList.contains('only-current') ? 
                    buttonConfirm.dataset.textOnlyCurrent :
                    buttonConfirm.dataset.textDefault;
            
        }

        //handle file upload reset on errors
        if(STEP_UPLOAD_IMAGE_NAME === stepName && this.step.startsWith('error')) {
            this.fileUploadForm.reset();
            const customFileInput = this.fileUploadForm.querySelector('.file-custom');
            if(!Boolean(customFileInput)) throw new HTMLElementNotFoundError('No custom file input found');
            customFileInput.click();
        }

        this.step = stepName;
        this.stepsElements.forEach((stepElement) => stepElement.classList.add('d-none'));
        const currentStepElement = this.stepsElements.find((stepElement) => stepElement.dataset.step === stepName);
        if(!Boolean(currentStepElement)) throw new Error(`Step ${stepName} not found`);
        currentStepElement.classList.remove('d-none');

    }

    setUpButtonNavigation = () => {
        const buttons = this.modal.querySelectorAll('button[data-step]');
        if(!buttons.length) throw new HTMLElementNotFoundError('No navigation buttons found');
        buttons.forEach((button) => {
            button.addEventListener('click', () => this.goToStep(button.dataset.step))
            if(button.dataset.step === STEP_WHEEL_CHOICE_NAME) {
                button.addEventListener('click', () => {
                    try {
                        this.setupPositionStep()
                    } catch (error) {
                        console.error(error);
                    }
                })
            }
            if(button.dataset.step === STEP_FINAL_NAME) {
                button.addEventListener('click', () => {
                    try {
                        this.submitResults()
                    } catch (error) {
                        console.error(error);
                    }
                })
            }
        })
    }
    
    setupPositionStep = () => {

        const choiceButton = this.modal.querySelector('#axTyreMotionAllResult .btn.active');
        if(!Boolean(choiceButton)) throw new HTMLElementNotFoundError('No choice button found');
        const result = JSON.parse(atob(choiceButton.dataset.result));
        if(result.tyre_dimensions.current && !Boolean(result.tyre_dimensions.oe_front) && !Boolean(result.tyre_dimensions.oe_rear)) {
            this.goToStep(STEP_FINAL_NAME);
            this.submitResults(result.tyre_dimensions.current);
        } else if(JSON.stringify(result.tyre_dimensions.oe_front) === JSON.stringify(result.tyre_dimensions.oe_rear)) {
            this.goToStep(STEP_FINAL_NAME);
            this.submitResults(result.tyre_dimensions.oe_front);
        } else {
            this.appender.appendChoicePositionButtons(result, 'front');
            this.appender.appendChoicePositionButtons(result, 'rear');
            this.listenerHelper.addClickEventListenerChoicePosition();
        }
    }

    setupResultsTopInfo = (results, response) => {
        const hasCurrent = results.some((result) => Boolean(result.tyre_dimensions.current));
        const hasFrontAndREar = results.some((result) => Boolean(result.tyre_dimensions.oe_front) && Boolean(result.tyre_dimensions.oe_rear));
        const hasBoth = hasCurrent && hasFrontAndREar;

        let wrapperClass = "";
        if(hasBoth) {
            wrapperClass = 'both';
        } else if(hasCurrent) {
            wrapperClass = 'only-current';
        } else if(hasFrontAndREar) {
            wrapperClass = 'only-models';
        }
        
        document.getElementById(AXTYREMOTION_RESULT_SEARCH_ID_ALL).setAttribute('class', wrapperClass);
    }

    submitResults = (single_result = null) => {
        let result = single_result;
        if(single_result === null) {
            const selectedResultElement = this.modal.querySelector(`.step[data-step="${STEP_WHEEL_CHOICE_NAME}"] .btn[data-result].active`);
            if(!Boolean(selectedResultElement)) throw new HTMLElementNotFoundError('No selected result found');
            result = JSON.parse(atob(selectedResultElement.dataset.result));
        }
        const formElement = document.getElementById("form-ax-tyres");
        if(!Boolean(formElement)) throw new HTMLElementNotFoundError('No form element found');

        formElement['width'].value = result.width;
        formElement['load_index'].value = result.load_index;
        formElement['height'].value = result.height;
        formElement['speed_index'].value = result.speed_index;
        formElement['radius'].value = result.diameter;

        if(result.load_index.includes(';') && null === this.loadIndexChoice) {
            try {
                this.setupLoadIndexStep(result.load_index, single_result);
            } catch(e) {
                console.error(e);
            } finally {
                return this.goToStep(STEP_LOAD_INDEX_CHOICE_NAME);
            }
        }

        if(null !== this.loadIndexChoice) {
            formElement['load_index'].value = this.loadIndexChoice;
        }

        if(result.speed_index.includes(';') && null === this.speedIndexChoice) {
            try {
                this.setupSpeedIndexStep(result.speed_index, single_result);
            } catch(e) {
                console.error(e);
            } finally {
                return this.goToStep(STEP_SPEED_INDEX_CHOICE_NAME);
            }
        }

        if(null !== this.speedIndexChoice) {
            formElement['speed_index'].value = this.speedIndexChoice;
        }
        
        if(Boolean(result.runflat) && Boolean(formElement['runflat']) && null === this.runflatChoice) {
            try {
                this.setupRunflatStep(single_result);
            } catch(e) {
                console.error(e);
            } finally {
                return this.goToStep('runflat');
            }
        }

        if(Boolean(result.runflat) && Boolean(formElement['runflat']) && null !== this.runflatChoice) {
            formElement['runflat'].checked = this.runflatChoice;
        } else if(Boolean(formElement['runflat'])) {
            formElement['runflat'].checked = false;
        }

        formElement.submit();
    }

    setupLoadIndexStep = (load_index, single_result) => {
        const axTyreMotionLoadIndexChoice = document.getElementById('axTyreMotionLoadIndexChoice');
        const prevButtons = axTyreMotionLoadIndexChoice.querySelectorAll('#axTyreMotionLoadIndexChoice .btn');
        if(prevButtons.length) {
            prevButtons.forEach(button => button.remove());
        }
        const loadIndexes = load_index.split(';');
        loadIndexes.forEach((loadIndex) => {
            this.appender.appendIndexButtons(loadIndex, axTyreMotionLoadIndexChoice);
        });
        const buttons = axTyreMotionLoadIndexChoice.querySelectorAll('#axTyreMotionLoadIndexChoice .btn');
        if(!buttons.length) throw new HTMLElementNotFoundError('No results found');
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this.loadIndexChoice = button.getAttribute('data-result');
                this.goToStep(STEP_FINAL_NAME);
                this.submitResults(single_result);
            })
        })
    }

    setupSpeedIndexStep = (speed_index, single_result) => {
        const axTyreMotionSpeedIndexChoice = document.getElementById('axTyreMotionSpeedIndexChoice');
        const prevButtons = axTyreMotionSpeedIndexChoice.querySelectorAll('#axTyreMotionSpeedIndexChoice .btn');
        if(prevButtons.length) {
            prevButtons.forEach(button => button.remove());
        }
        const speedIndexes = speed_index.split(';');
        speedIndexes.forEach((speedIndex) => {
            this.appender.appendIndexButtons(speedIndex, axTyreMotionSpeedIndexChoice);
        });
        const buttons = axTyreMotionSpeedIndexChoice.querySelectorAll('#axTyreMotionSpeedIndexChoice .btn');
        if(!buttons.length) throw new HTMLElementNotFoundError('No results found');
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                this.speedIndexChoice = button.getAttribute('data-result');
                this.goToStep(STEP_FINAL_NAME);
                this.submitResults(single_result);
            })
        })
    }

    setupRunflatStep = (single_result) => {
        const enableRunflatButtonElement = document.getElementById('enable-runflat');
        if(!Boolean(enableRunflatButtonElement)) throw new HTMLElementNotFoundError('No enable runflat button found');
        const disabledRunflatButton = document.getElementById('disable-runflat');
        if(!Boolean(disabledRunflatButton)) throw new HTMLElementNotFoundError('No disable runflat button found');
        const runflatButtons = [enableRunflatButtonElement, disabledRunflatButton];
        if(!runflatButtons.length) throw new HTMLElementNotFoundError('No runflat buttons found');
        runflatButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.runflatChoice = (button === enableRunflatButtonElement) ? true : false;
                this.goToStep(STEP_FINAL_NAME);
                this.submitResults(single_result);
            })
        })
    }

    isTyremotionHealthy = () => {
        return axios.get(ax_tyremotion.health_url)
            .then(response => {
                return (response.status === 200);
            });
    }
}